import { useNavigate } from 'react-router-dom';
import ResetPwd from './Login/ResetPwd';
import PageTransition from '../components/PageTransition';

export default function ChangePassword() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/');
  };

  return (
    <PageTransition>
      <div className="w-full flex items-center justify-center -mt-20">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-slate-900 mb-2">修改密码</h1>
            <p className="text-slate-600">请验证您的身份后设置新密码</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl shadow-slate-900/5 p-8 border border-slate-200">
            <ResetPwd onSuccess={handleSuccess} />
          </div>
        </div>
      </div>
    </PageTransition>
  );
}
